import React, { useEffect, useState } from "react";
import "../styles/Holiday.css";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { secretKey } from "../.././data";

const MySwal = withReactContent(Swal2);

const BlockHolidayPopUp = (props) => {
  const [dateFrom, setDateFrom] = useState(
    props.mode === "edit" ? props.block.date_from : ""
  );
  const [dateTo, setDateTo] = useState(
    props.mode === "edit" ? props.block.date_to : ""
  );

  const handleDateFromChange = (e) => {
    setDateFrom(e.target.value);
  };

  const handleDateToChange = (e) => {
    setDateTo(e.target.value);
  };

  const checkBlock = () => {
    var blocks = props.holidaysBlockData;
    var bool = false;
    if (blocks.length === 0) {
      return bool;
    } else {
      blocks.map((el) => {
        if (
          (el.date_from >= dateFrom && el.date_from <= dateTo) ||
          (dateFrom >= el.date_from && dateFrom <= el.date_to)
        ) {
          bool = true;
        }
      });
    }

    return bool;
  };

  const checkBlockEdit = () => {
    var blocks = props.holidaysBlockData.filter(
      (el) => el.id !== props.block.id
    );
    var bool = false;
    if (blocks.length === 0) {
      return bool;
    } else {
      blocks.map((el) => {
        if (
          (el.date_from >= dateFrom && el.date_from <= dateTo) ||
          (dateFrom >= el.date_from && dateFrom <= el.date_to)
        ) {
          bool = true;
        }
      });
    }

    return bool;
  };

  const validateBlock = () => {
    if (dateFrom.length > 0 && dateTo.length > 0) {
      return true;
    }
    return false;
  };

  const addBlock = async (e) => {
    if (validateBlock()) {
      if (checkBlock()) {
        MySwal.fire({
          icon: "error",
          title: "Data blokady",
          text: "pokrywa się z innym zakresem blokady",
        });
      } else {
        var body = {
          date_from: dateFrom,
          date_to: dateTo,
        };

        await fetch("https://apidevkppp.ftpeople.pl/addBlockHoliday", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.json())
          .then((data) => {})
          .catch((error) => {});
        MySwal.fire({
          icon: "success",
          title: "Dodano",
          text: "termin blokady",
        }).then((result) => {
          props.close();
        });
      }
    } else {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Wypełnij wymagane pola formularza",
      });
    }
  };

  const editBlock = async (e) => {
    if (validateBlock()) {
      if (checkBlockEdit()) {
        MySwal.fire({
          icon: "error",
          title: "Data blokady",
          text: "pokrywa się z innym zakresem blokady",
        });
      } else {
        var body = {
          id: props.block.id,
          date_from: dateFrom,
          date_to: dateTo,
        };

        await fetch("https://apidevkppp.ftpeople.pl/addBlockHoliday", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.json())
          .then((data) => {})
          .catch((error) => {});

        MySwal.fire({
          icon: "success",
          title: "Zmieniono",
          text: "termin blokady",
        }).then((result) => {
          props.close();
        });
      }
    } else {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Wypełnij wymagane pola formularza",
      });
    }
  };

  const deleteBlock = (e) => {
    MySwal.fire({
      title: "Czy na pewno usunąć blokadę?",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "Tak",
      denyButtonText: `Nie`,
    }).then((result) => {
      if (result.isConfirmed) {
        deleteBlockFinal();
      } else if (result.isDenied) {
        return;
      }
    });
  };

  const deleteBlockFinal = async (e) => {
    var body = {
      id: props.block.id,
    };

    await fetch("https://apidevkppp.ftpeople.pl/deleteBlockHoliday", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {})
      .catch((error) => {});

    MySwal.fire({
      icon: "success",
      title: "Usunięto",
      text: "blokadę",
    }).then((result) => {
      props.close();
    });
  };

  return (
    <>
      <div className="mainContainerBlockPopUp">
        <div className="closeBox">
          <button className="closeClientButton" onClick={props.close}>
            X
          </button>
        </div>
        <div className="inputBox">
          <div className="inputCol_1">
            <label>
              Data rozpoczęcia blokady <span className="requiredStar">*</span>
            </label>
            <input
              type="date"
              id="name"
              name="name"
              value={dateFrom}
              onChange={handleDateFromChange}
            />
          </div>
        </div>
        <div className="inputBox">
          <div className="inputCol_1">
            <label>
              Data zakończenia blokady <span className="requiredStar">*</span>
            </label>
            <input
              type="date"
              id="name"
              name="name"
              value={dateTo}
              onChange={handleDateToChange}
            />
          </div>
        </div>
        <div className="saveBoxH">
          <button
            className="paymentMenuButton"
            onClick={props.mode === "edit" ? editBlock : addBlock}
          >
            zapisz
          </button>
          {props.mode === "edit" ? (
            <button className="paymentMenuButton" onClick={deleteBlock}>
              Usuń blokadę
            </button>
          ) : (
            ""
          )}
        </div>
      </div>
    </>
  );
};

export default BlockHolidayPopUp;
